import React, {Component} from 'react'
import InputUnitOfMeasure from "../unit-of-measure/input.component.jsx"
import Icon from "../icon/icon.component.jsx";
import {FormattedMessage} from "react-intl";

class CopyableInputForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = this.getDefaultState(props)
        this.copyElement = this.copyElement.bind(this)
        this.clearCopy = this.clearCopy.bind(this)
    }

    getDefaultState(props) {
        return {
            groupClassName: props.groupClassName || 'input-group',
            inputClassName: props.inputClassName || 'form-control',
            btnClassName: props.btnClassName || 'btn-primary',
            type: props.type || 'text',
            originalType: props.type || 'text',
            className: props.className || '',
            name: props.name || '',
            value: props.value || '',
            onChange: props.onChange || function () {},
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.getDefaultState(nextProps))
    }

    copyElement(e) {
        e.preventDefault()
        let copyText = document.getElementById(this.state.name)
        copyText.select()
        copyText.setSelectionRange(0, 99999) /*For mobile devices*/
        this.setState({
            type: 'text',
            buttonCopyLabel: <FormattedMessage
                id="common.form.input.copied_btn"
                defaultMessage="Copied!"
            />
        }, () => {
            document.execCommand("copy")
        })
        setTimeout(this.clearCopy, 2000)
    }

    clearCopy() {
        this.setState({
            type: this.state.originalType,
            buttonCopyLabel: ''
        })
    }

    render() {
        return (
            <div className={this.state.groupClassName}>
                <input
                    id={this.state.name}
                    name={this.state.name}
                    value={this.state.value}
                    type={this.state.type}
                    className={this.state.inputClassName}
                    onChange={this.state.onChange}
                />
                <div className="input-group-append">
                    <button className={"btn "+ (this.state.buttonCopyLabel ? 'btn-success' : this.state.btnClassName)}  type="button" onClick={this.copyElement}>
                        <Icon value={"copy"} className={"mr-1"} />
                        {this.state.buttonCopyLabel ? this.state.buttonCopyLabel : <FormattedMessage
                            id="common.form.input.copy_btn"
                            defaultMessage="Copy"
                        />}
                    </button>
                </div>
            </div>
        )
    }
}

export default CopyableInputForm


// WEBPACK FOOTER //
// ./src/common/form/copyableinput.component.jsx